// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"E8-z"};